<template>
  <b-navbar
    toggleable="lg"
    :variant="getLayoutNavbarBg()"
    class="layout-navbar align-items-lg-center container-p-x"
    style="height: 85px;"
  >
    <b-navbar-nav class="align-items-lg-center mr-auto mr-lg-4" v-if="sidenavToggle">
      <a
        class="nav-item nav-link px-0 ml-2 ml-lg-0"
        href="javascript:void(0)"
        @click="toggleSidenav"
      >
        <i class="ion ion-md-menu text-large align-middle"/>
      </a>
      <div class="logo-wrapper ml-5">
        <img src="/logo_white.png" alt="" class="img-fluid logo">
      </div>
    </b-navbar-nav>
    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>
    <b-collapse is-nav id="app-layout-navbar">
      <b-navbar-nav class="align-items-lg-center ml-auto">
        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
          <template slot="button-content">
            <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
              <!-- <img :src="`${baseUrl}img/avatars/1.png`" alt class="d-block ui-w-30 rounded-circle"> -->
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ userName }}</span>
            </span>
          </template>
          <b-dd-item @click="profile()">
            <i class="ion ion-ios-person text-lightest"></i> &nbsp; Profil
          </b-dd-item>
          <b-dd-item @click="settings()">
            <i class="ion ion-md-settings text-lightest"></i> &nbsp; Ustawienia
          </b-dd-item>
          <b-dd-divider/>
          <b-dd-item @click="logout()">
            <i class="ion ion-ios-log-out text-dark"></i> &nbsp; Wyloguj
          </b-dd-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import router from "@/router";

export default {
  name: "app-layout-navbar",
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
    getLayoutNavbarBg() {
      return 'navbar-default';
    },
    profile() {
      router.push({
        path: `/profile/${this.userId}`
      });
    },
    settings() {
      router.push({
        path: `/settings/${this.userId}`
      });
    },
    logout() {
      this.$store.dispatch("logout");
    }
  },
  created() {
    // if (!this.enums || !this.enums.userRoles) this.$store.dispatch("enums");
  },
  computed: {
    userId() {
      return this.$store.getters.userId;
    },
    userName() {
      return this.$store.getters.userName;
    }
  }
};
</script>
